export enum TicketStatusCode {
    ideas = 'ideas',
    problems = 'problems'
}
